namespace SPA
{
	export namespace gui
	{
		export namespace component
		{

			export interface CheckableListOptions extends ui.Form.IBasicInputDescriptor
			{
				multiple?:		boolean;
				horizontal?:	boolean;
			}

			export interface CheckableListItemOptions extends ui.Form.IBasicInputDescriptor
			{
				multiple?: boolean;
			}

			export class CheckableListItem
				extends ui.base.BaseHTMLElement
			{

				public readonly	Value:			any;
				public readonly	Default:		boolean;
				public readonly	Options:		ui.base.IBaseHTMLElementDescriptor;

				private		m_Checked:	boolean;
				private		m_Parent:		CheckableList;

				public constructor( value: any, checked: boolean, options: CheckableListItemOptions, parent: CheckableList )
				{
					super( 'item' );

					this.Value			= value;
					this.Default		= checked;
					this.Options		= options;

					this.m_Checked	= checked;
					this.m_Parent		= parent;
				}

				public Initialize(): CheckableListItem
				{
					super.Initialize( this.Options );

					this.on(
						{
							click: () => this.val( !this.m_Checked )
						}
					);

					if ( this.m_Checked ) { this.addClass( 'active' ); }

					return this;
				}

				public isChecked(): boolean
				{
					return this.m_Checked;
				}

				public val(): boolean;
				public val( value: boolean ): CheckableListItem;

				public val( value?: boolean ): boolean|CheckableListItem
				{
					if ( value !== undefined )
					{
						if ( this.m_Parent.isStatic() ) { return this; }

						if ( !value )
						{
							this.remClass( 'active' );

							this.m_Checked	= false;
						}
						else
						{
							if ( !this.m_Parent.Multiselect )
							{
								this.m_Parent.allToFalse();
							}

							this.addClass( 'active' );

							this.m_Checked	= true;
						}

						return this;
					}

					return this.m_Checked;
				}

				public reset(): void
				{
					this.m_Checked	= this.Default;
				}

			}

			/**
			 * @version 1.0.0 First implementation
			 */
			export class CheckableList
				extends ui.Form.BasicInputField
			{

				public readonly	Multiselect: boolean;

				public		m_Items: CheckableListItem[];

				public constructor( options: CheckableListOptions )
				{
					super( 'checkable-list', options, ui.Form.InputValueTypes.ANY );

					this.m_Items			= new Array();
					this.Multiselect	= options.multiple === true;
				}

				public Initialize(): CheckableList
				{
					super.Initialize();

					this.Input().removeClass( 'form-control' );

					if ( ( this.Descriptor as CheckableListOptions ).horizontal )
					{
						this.Input().addClass( 'horizontal' );
					}

					return this;
				}

				public clear(): void
				{
					this.m_Root.empty();
					this.m_Items	= new Array();
				}

				/**
				 * Creates a new item, adds it to this list and returns it for manipulation.
				 *
				 * @param value The value for the new item which will be returned if selected. NOTE: `undefined` will be transformed to `null`.
				 * @param checked optional Set this to true to force selected/checked state. Default: false
				 * @param options optional Additional options for the new item.
				 * @since 1.0.0
				 */
				public add( value: any, checked?: boolean, options?: CheckableListItemOptions ): CheckableListItem
				{
					const item = new CheckableListItem( value === undefined ? null : value, checked || false, options || {}, this );

					this.m_Items.push( item );

					return item;
				}

				public Static( is_static_now: boolean ): void
				{
					this.m_Static	= is_static_now;
				}

				public reset(): void
				{
					this.m_Items.forEach( (item) => item.reset() );
				}

				public allToFalse(): void
				{
					this.m_Items.forEach( (item) => item.val( false ) );
				}

				public value( vals: number[] ): CheckableList
				{
					if ( vals.length > 0 )
					{
						this.m_Items.forEach( ( item, idx ) => { if ( $.inArray( idx, vals ) ) { item.val( true ); } else { item.val( false ); } } );
					}

					return this;
				}

				/**
				 * @returns any Returns the value of the checked item(s). Will never return `undefined`.
				 */
				public val(): any;
				/**
				 * @returns any Returns `undefined` to identify that nothing was selected.
				 */
				public val(): undefined;

				public val(): any|undefined
				{
					const vals: any[] = new Array();

					this.m_Items.forEach( (item) => { if ( item.isChecked() ) { vals.push( item.Value ); } } );

					if ( vals.length === 0 ) { return undefined; }

					return this.Multiselect ? vals : vals[ 0 ];
				}

				public CheckIfValid(): boolean
				{
					return this.val() !== undefined || !this.required();
				}

				public rebuild( root: JQuery|ui.base.BaseHTMLElement ): CheckableList
				{
					super.rebuild( root );

					this.m_Items.forEach( (item) => item.Initialize().appendTo( this.Input() ) );

					return this;
				}

			}

		}
	}
}
